// material-ui
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { useMemo, useContext } from 'react';

// project import
import NavGroup from './NavGroup';
import NavItem from './NavItem';
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import { AuthContext } from 'contexts/AuthContext';
import { getStoredUser } from 'utils/accessControl';
import { getIconComponent } from 'utils/iconMapper';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

// Helper to recursively map the backend tree format to the frontend UI format
const mapBackendMenuToFrontend = (menuNode) => {
  const hasChildren = menuNode.children && menuNode.children.length > 0;
  
  let title = menuNode.display_name || menuNode.name || 'Unknown';
  if ((menuNode.route === '/billing/transactions' || menuNode.code === 'billing_transactions') && title === 'Transactions') {
    title = 'Transaction History';
  }

  const mappedNode = {
    id: menuNode.id || menuNode.code || String(Math.random()),
    title,
    type: hasChildren ? 'group' : 'item',
    url: menuNode.route || menuNode.url || '#',
    icon: getIconComponent(menuNode.icon),
    breadcrumbs: false,
    code: menuNode.code,
    is_granted_override: menuNode.is_granted_override || false
  };

  if (hasChildren) {
    mappedNode.children = menuNode.children.map(mapBackendMenuToFrontend);
  }

  return mappedNode;
};

export default function Navigation() {
  const { user: authUser } = useContext(AuthContext);
  const user = authUser || getStoredUser();

  const visibleItems = useMemo(() => {
    const backendMenus = Array.isArray(user?.menus) ? user.menus : [];
    
    if (backendMenus.length > 0) {
      return backendMenus.map(mapBackendMenuToFrontend);
    }
    
    // Fallback if backend hasn't provided menus
    return [
      {
        id: 'group-dashboard',
        title: 'Navigation',
        type: 'group',
        children: [
          {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/default',
            icon: DashboardOutlined,
            breadcrumbs: false
          }
        ]
      }
    ];
  }, [user]);

  const navGroups = visibleItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        // Render standalone root link directly instead of wrapping in a dummy group
        return (
          <List key={item.id} sx={{ mb: 0.5, py: 0, px: 0.5 }}>
            <NavItem item={item} level={1} isParents={true} />
          </List>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
